import WidgetModule from "@eisinc/Overrides/Widgets/Common/RecentQuotes";

export * from "@eisinc/Overrides/Widgets/Common/RecentQuotes";

export default WidgetModule;
